import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        padding-left: ", ";\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  @media screen and ", " {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { Icon } from '@scp/ui-shared/theme/icons';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { baselineToPx } from '@scp/ui-shared/theme/utils';
import { mediaQueryTabletMax } from '@scp/ui-shared/theme/responsive';
import { E2E_BACK_SUFFIX, E2E_CLOSE_SUFFIX, E2E_HEADER_SUFFIX, HEADER_TEXT } from './constants';
import { ContentWrapper, HeaderButton, Heading, SecondaryActions } from './baseComponents';
import { HeaderWrapper, InnerWrapper } from './Header';
var HeaderInnerResponsive = styled(InnerWrapper)(_templateObject(), mediaQueryTabletMax, function (props) {
  return !!props.$hasSideNavigation && css(_templateObject2(), baselineToPx(14));
});
export var HeaderResponsive = function HeaderResponsive(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      onGoBack = _ref.onGoBack,
      secondaryActions = _ref.secondaryActions,
      headingAs = _ref.headingAs,
      onClick = _ref.onClick,
      linkTo = _ref.linkTo,
      title = _ref.title,
      hideShadow = _ref.hideShadow,
      noGutter = _ref.noGutter,
      dataE2e = _ref.dataE2e,
      _ref$hasSideNavigatio = _ref.hasSideNavigation,
      hasSideNavigation = _ref$hasSideNavigatio === void 0 ? true : _ref$hasSideNavigatio;
  var wholeHeaderClickable = !!(onClick || linkTo);
  var clickableProps = wholeHeaderClickable && {
    as: withoutProps(withRippleEffect(linkTo ? Link : 'div'), ['spaced']),
    role: !linkTo ? 'button' : undefined,
    tabIndex: !linkTo ? 0 : undefined,
    onClick: onClick,
    onKeyDown: function onKeyDown(e) {
      if (onClick && (e.key === 'Enter' || e.key === ' ')) {
        onClick();
      }
    },
    title: title,
    to: linkTo
  };
  var dataE2eBackLabel = getE2eLabel(children, E2E_BACK_SUFFIX, dataE2e);
  var dataE2eCloseLabel = getE2eLabel(children, E2E_CLOSE_SUFFIX, dataE2e);
  var dataE2eHeaderLabel = getE2eLabel(children, E2E_HEADER_SUFFIX, dataE2e);
  return React.createElement(HeaderWrapper, {
    hideShadow: hideShadow
  }, React.createElement(HeaderInnerResponsive, Object.assign({
    noGutter: noGutter,
    spaced: !wholeHeaderClickable && !!(onGoBack || onClose),
    "$hasSideNavigation": hasSideNavigation
  }, clickableProps), !wholeHeaderClickable && React.createElement(React.Fragment, null, onGoBack && React.createElement(HeaderButton, {
    title: HEADER_TEXT.GO_BACK,
    onClick: onGoBack,
    dataE2e: dataE2eBackLabel
  }, React.createElement(Icon, {
    name: "arrow-back"
  })), onClose && React.createElement(HeaderButton, {
    title: HEADER_TEXT.CLOSE,
    onClick: onClose,
    dataE2e: dataE2eCloseLabel
  }, React.createElement(Icon, {
    name: "close"
  }))), React.createElement(ContentWrapper, {
    "data-e2e": dataE2eHeaderLabel
  }, typeof children === 'string' ? React.createElement(Heading, {
    as: headingAs
  }, children) : children), secondaryActions && React.createElement(SecondaryActions, null, secondaryActions)));
};